import React, { useState, useEffect } from 'react';
import { Modal } from 'reactstrap';
import { SOURCE_LABELS, SOURCE_ICONS, ACTION_META } from '../shared/auditSources';

// Modal de AUDITORÍA DE DATOS. Sirve para las dos capas:
//   - mode "format": historial de configuración de un formato (config_audits)
//   - mode "record": historial de ediciones de un registro (survey_audits)
// Ambos endpoints devuelven el mismo contrato {audits:[{user, created_at,
// source, changes:[{question, before, after}]}]}; el de configuración añade
// `action` y `entity`, que este componente usa cuando están presentes.
const FORMAT_FILTERS = [
    { value: '', label: 'Todo' },
    { value: 'Format', label: 'Formato' },
    { value: 'Step', label: 'Secciones' },
    { value: 'Question', label: 'Campos' },
    { value: 'ConfigurationFormat', label: 'Configuración' },
];

const AuditModal = ({ mode = 'format', targetId, title, subtitle, toggle, showTrashLink = false }) => {
    const [audits, setAudits] = useState([]);
    const [loading, setLoading] = useState(true);
    const [entity, setEntity] = useState('');

    const isFormat = mode === 'format';

    useEffect(() => {
        setLoading(true);
        const url = isFormat
            ? `/formatos/get_format_config_audits/${targetId}${entity ? `?entity=${entity}` : ''}`
            : `/formatos/get_survey_audits/${targetId}`;

        fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(r => r.json())
            .then(data => setAudits(data.audits || []))
            .catch(() => setAudits([]))
            .finally(() => setLoading(false));
    }, [targetId, entity, isFormat]);

    return (
        <Modal isOpen toggle={toggle} className="modal-dialog-centered rk-modal modal-lg" backdrop="static">
            <div className="rk-modal__header">
                <span className="rk-modal__header-icon"><i className="fas fa-history"></i></span>
                <h5>
                    Auditoría de datos
                    {title && <span className="rk-cell-muted" style={{ fontWeight: 400 }}> — {title}</span>}
                </h5>
                <button type="button" className="rk-modal__close" onClick={toggle}>
                    <i className="fas fa-times"></i>
                </button>
            </div>

            <div className="rk-modal__body">
                {subtitle && (
                    <p className="rk-cell-muted" style={{ marginTop: -4, marginBottom: 14 }}>{subtitle}</p>
                )}

                {isFormat && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 14 }}>
                        {FORMAT_FILTERS.map(f => (
                            <button
                                key={f.value}
                                type="button"
                                className={`rk-btn ${entity === f.value ? 'rk-btn--primary' : 'rk-btn--ghost'}`}
                                onClick={() => setEntity(f.value)}
                            >
                                {f.label}
                            </button>
                        ))}
                    </div>
                )}

                {/* Alto FIJO: sin esto el modal salta de tamaño al cambiar de
                    filtro (Formato / Secciones / Campos tienen distinta cantidad
                    de entradas) y se ve como una transición brusca. */}
                <div style={{ height: '48vh', minHeight: 280, overflowY: 'auto' }}>
                    {loading ? (
                        <div className="rk-cell-muted">Cargando historial…</div>
                    ) : !audits.length ? (
                        <div className="rk-empty" style={{ height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <i className="fas fa-history"></i>
                            <p>
                                {entity
                                    ? 'Sin cambios registrados para este filtro'
                                    : 'Sin cambios registrados'}
                            </p>
                        </div>
                    ) : (
                        audits.map(a => {
                            const meta = ACTION_META[a.action] || ACTION_META.updated;
                            return (
                                <div key={a.id} className="rk-audit-item">
                                    <div className="rk-audit-item__head">
                                        <i className={meta.icon} style={{ color: meta.color, marginRight: 6 }}></i>
                                        <b>{a.user}</b>
                                        {a.action && <span className="rk-cell-muted"> {meta.label.toLowerCase()}</span>}
                                        {a.entity && (
                                            <>
                                                {' '}<span className="rk-chip">{a.entity.kind}</span>
                                                {' '}<span className="rk-cell-primary">{a.entity.label}</span>
                                            </>
                                        )}
                                        {SOURCE_LABELS[a.source] && (
                                            <span className="rk-chip ml-1" title="Origen del cambio">
                                                <i className={`${SOURCE_ICONS[a.source]} mr-1`}></i>
                                                {SOURCE_LABELS[a.source]}
                                            </span>
                                        )}
                                        <span className="rk-cell-muted"> · {a.created_at}</span>
                                    </div>
                                    {a.changes && a.changes.length > 0 && (
                                        <ul className="rk-audit-item__changes">
                                            {a.changes.map((c, i) => (
                                                <li key={i}>
                                                    <span className="rk-cell-primary">{c.question}:</span>{' '}
                                                    <span className="rk-cell-muted">{c.before || '(vacío)'}</span>
                                                    {' → '}
                                                    <span>{c.after || '(vacío)'}</span>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>

            <div className="rk-modal__footer">
                {showTrashLink && (
                    <a href="/formatos/deleted_records" className="rk-btn rk-btn--ghost" style={{ marginRight: 'auto' }}>
                        <i className="fas fa-recycle"></i> Ver registros eliminados
                    </a>
                )}
                <button className="rk-btn rk-btn--ghost" onClick={toggle}>Cerrar</button>
            </div>
        </Modal>
    );
};

export default AuditModal;
